module.exports = {
  messages: {
    ADVERTISING_DIGITAL_SERVICE_ACT_HEADLINE: '¿Por qué veo este anuncio?',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_CTA: 'Más información',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_MESSAGE:
      'sobre los criterios de grupo meta.',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_MESSAGE:
      'Estás viendo este anuncio porque tu perfil responde a los criterios del anunciante.',
    ADVERTISING_LEAD_AD_FORM_CHECKBOX_ERROR: 'Marca la casilla para continuar',
    CARDS_SECTION_DESCRIPTION: 'Criterios de búsqueda frecuentes:',
    CARDS_SECTION_REGISTRATION_BUTTON_TEXT: 'Registrarme ahora',
    CARDS_SECTION_REGISTRATION_TEXT:
      'Únete a XING y multiplica tus opciones de búsqueda.',
    CARDS_SECTION_TITLE: 'Encuentra trabajo de forma inteligente',
    CAREER_HUB_TEASER_CARD_DESCRIPTION:
      'Accede a artículos interesantes y recibe consejo especializado de profesionales y expertos del sector.',
    CAREER_HUB_TEASER_CARD_TITLE: 'Descubre la guía profesional de XING',
    COMPANIES_SECTION_SUBTITLE:
      'Entra en contacto con más de 20 000 reclutadores y reclutadoras',
    COMPANIES_SECTION_TITLE:
      'Entra en contacto con más de 20 000 reclutadores y reclutadoras',
    CP_HIRING: 'Ofertas disponibles',
    'CP_TOP_COMPANIES_CARD_BUTTON.one': 'View {value} job',
    'CP_TOP_COMPANIES_CARD_BUTTON.other': 'View {value} jobs',
    CP_TOP_COMPANIES_CARD_HIGHLIGHT:
      '{percentage}% recommendation rate on kununu',
    CRATE_LOSP_CAREER_HUB_CARD_DESCRIPTION:
      'Read interesting articles and get advice from seasoned experts and Insiders.',
    CRATE_LOSP_CAREER_HUB_CARD_TITLE: 'Visit the Career Guide',
    CRATE_LOSP_CV_CARD_DESCRIPTION:
      'Make a great first impression and land the interviews you want.',
    CRATE_LOSP_CV_CARD_TITLE: 'Build a professional CV in minutes',
    CRATE_LOSP_PROFILE_CARD_DESCRIPTION:
      'Create a profile, set your job preferences, and watch the offers come to you!',
    CRATE_LOSP_PROFILE_CARD_TITLE: 'Let the jobs come to you!',
    CRATE_LOSP_REGISTER_BUTTON: 'Create profile',
    CRATE_LOSP_REGISTER_WITH_GOOGLE_BUTTON: 'Continue with Google',
    DESCRIPTION_CARD_1: 'Trabaja donde mejor te sientes.',
    DESCRIPTION_CARD_2: 'Trabaja cuando quieras.',
    DESCRIPTION_CARD_3: 'Averigua en qué ofertas encajan tus cualidades.',
    DESCRIPTION_CARD_4: 'Cobra lo que te mereces.',
    DESCRIPTION_CARD_5: 'Guarda tiempo para lo importante en la vida.',
    DESCRIPTION_CARD_6: 'Por si quieres empezar poco a poco.',
    'DISCO_OBJECTS_FOLLOWER.one': 'seguidor',
    'DISCO_OBJECTS_FOLLOWER.other': 'seguidores',
    'DISCO_OBJECTS_FOLLOWER.zero': 'seguidores',
    ERROR_REGISTER_EMAIL_MAX_CHANGE:
      'Puedes cambiar tu dirección de correo electrónico un máximo de 10 veces.',
    JOBS_FIND_JOBS_FLEXITIME_OPTION_FLEXITIME: 'Horarios flexibles',
    JOBS_FIND_JOBS_HEADER_TITLE: 'Encuentra el trabajo que más te conviene.',
    JOBS_FIND_JOBS_PART_TIME_OPTION_PART_TIME: 'Media jornada',
    JOBS_FIND_JOBS_RECRUITERS_LINK: '¿Publicar una oferta? <a>Hazlo aquí.</a>',
    JOBS_FIND_JOBS_REMOTE_OPTION_FULL_REMOTE: 'Teletrabajo',
    JOBS_FIND_JOBS_SEARCH_BUTTON: 'Buscar ofertas de empleo',
    JOBS_FIND_JOBS_SEARCH_LOCATION_PLACEHOLDER: 'Ubicación',
    JOBS_FIND_JOBS_SEARCH_PLACEHOLDER: 'Introducir el cargo',
    JOBS_FIND_JOBS_SEARCH_RADIUS_PLACEHOLDER: 'Radio',
    JOBS_FIND_JOBS_TITLE: 'Buscar ofertas',
    JOBS_JOB_TEASER_SAVE: 'Guardar oferta',
    JOBS_JOB_TEASER_SAVED: 'Guardado en "favoritos"',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_ONE:
      'Más de 1 millón \nde ofertas de empleo',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_THREE:
      'Seminarios web sobre la búsqueda de empleo',
    JOBS_LANDING_LO_MARKETING_SEC_ONE_TEXT_TWO:
      'Más de 20 millones\nde usuarios y usuarias',
    JOBS_RECENT_SEARCH_EMPTY: 'Todas las ofertas',
    JOBS_SEARCH_AI_ENTRYPOINT_BANNER: 'New: Find your next job with AI',
    JOBS_SEARCH_AI_ENTRYPOINT_FLAG_DESKTOP: 'Try it here',
    JOBS_SEARCH_AI_ENTRYPOINT_FLAG_MOBILE: 'Try here',
    JOBS_SEARCH_AI_FLAG: 'AI-enhanced',
    JOBS_SEARCH_AI_HEADLINE: 'Welcome to a new breed of job search',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_1: 'Describe your ideal job…',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_10: 'Include your skills and experience',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_2:
      'Enter a description in full sentences…',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_3: 'Outline the jobs you’d like to do…',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_4: 'List ideas for your next career step…',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_5:
      'Job title, career level, salary expectations',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_6: 'Everything that’s important to you',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_7:
      'The more specific you can be, the better',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_8:
      'Part-time or full-time, work from home, in the office, or both',
    JOBS_SEARCH_AI_INPUT_PLACEHOLDER_9: 'Avoid using just keywords',
    JOBS_SEARCH_AI_PLACEHOLDER_1: 'Describe your dream job. Go wild!',
    JOBS_SEARCH_AI_PLACEHOLDER_2:
      'Every bit of detail helps improve your results',
    JOBS_SEARCH_AI_PLACEHOLDER_3:
      'Add your preferred job title, level, industry, etc.',
    JOBS_SEARCH_AI_PLACEHOLDER_4: 'Full- or part-time? Remote or in an office?',
    JOBS_SEARCH_AI_PLACEHOLDER_5: 'Include your skills and strengths',
    JOBS_SEARCH_AI_PLACEHOLDER_6: 'And how much you want to earn',
    JOBS_SEARCH_AI_PLACEHOLDER_7:
      "Play around with your description until you're happy with it",
    JOBS_SEARCH_AI_SWIMP_SUGGESTION: 'Search with my profile',
    JOBS_SEARCH_AI_SWIMP_SUGGESTION_SUBTITLE:
      'Discover your next step with XING AI',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION: 'I want to change careers',
    JOBS_SEARCH_AI_SWIMS_SUGGESTION_SUBTITLE:
      'Explore your options with XING AI',
    JOBS_SEARCH_LOCATION_NO_RADIUS: 'Sin radio',
    LEBENSLAUF_TEASER_CARD_DESCRIPTION:
      'Multiplica tus oportunidades en un abrir y cerrar de ojos.',
    LEBENSLAUF_TEASER_CARD_TITLE: 'Crea un CV profesional',
    LOGGED_OUT_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      'Más de 1 millón de ofertas ✓ 20.000 Reclutadores(as) ✓ Estimaciones salariales ✓ Evaluaciones de empleadores. ¡Define tus expectativas laborales y crea tu propio XING!',
    LOGGED_OUT_STARTPAGE_META_TITLE_JOB_SEARCH:
      'Encuentra el trabajo perfecto para ti o consigue que el trabajo venga a ti.',
    LOSP_JOBS_SECTION_SUBTITLE:
      'Browse the most-popular vacancies from the past week.',
    LOSP_JOBS_SECTION_TITLE: 'Trending jobs',
    LOSP_KEYWORDS_ACCOUNTANT: '🧮 accountant',
    LOSP_KEYWORDS_ADMINISTRATION: '🏫 administration',
    LOSP_KEYWORDS_ANALYST: '📈 data analyst',
    LOSP_KEYWORDS_BANKER: '💸 banker',
    LOSP_KEYWORDS_CALLCENTER: '📞 call centre',
    LOSP_KEYWORDS_CAREERCHANGER: '👣 career changer',
    LOSP_KEYWORDS_CARETAKER: '👨‍🔧 caretaker',
    LOSP_KEYWORDS_CONTROLLER: '🎚️ controller',
    LOSP_KEYWORDS_DESIGN: '🎨 design jobs',
    LOSP_KEYWORDS_FLIGHTATTENDANT: '🛫 flight attendant',
    LOSP_KEYWORDS_FORKLIFT: '👷 forklift driver',
    LOSP_KEYWORDS_FOUNDATION: '🏛️ foundation',
    LOSP_KEYWORDS_FREELANCE: '👨🏻‍💻 freelance jobs',
    LOSP_KEYWORDS_HEALTH: '🥕 health manager',
    LOSP_KEYWORDS_LOGISTICS: '📦 logistics jobs',
    LOSP_KEYWORDS_MARKETING: '📣 marketing jobs',
    LOSP_KEYWORDS_MUSEUM: '🖼️ museum jobs',
    LOSP_KEYWORDS_NURSERY: '👶 nursery teacher',
    LOSP_KEYWORDS_OFFICECLERK: '👩‍💻 office clerk',
    LOSP_KEYWORDS_PROJECTMANAGER: '🤹 project manager',
    LOSP_KEYWORDS_PSYCHOLOGIST: '🛋️ psychologist',
    LOSP_KEYWORDS_SALES: '💼 sales representative',
    LOSP_KEYWORDS_SALES2: '💰 sales',
    LOSP_KEYWORDS_SECURITY: '👮🏻 security officer',
    LOSP_KEYWORDS_SOCIALMEDIA: '🤳 social media manager',
    LOSP_KEYWORDS_SOCIALWORKER: '👨‍👧‍👦 social worker',
    LOSP_KEYWORDS_SOCIALWORKER2: '❤️‍🔥 social worker',
    LOSP_KEYWORDS_SUSTAINABILITY: '🌿 sustainability jobs',
    LOSP_KEYWORDS_TRUCK: '🚚 lorry driver',
    LOSP_KEYWORDS_WORKINGSTUDENT: '🧑🏽‍🎓 working student',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BERLIN: 'Berlín',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_BUTTON: 'Ciudades',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HAMBURG: 'Hamburgo',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_HEADLINE:
      '¿En qué ciudad quieres trabajar?',
    LOSP_PREFERENCES_EXPERIMENT_CITIES_MUNICH: 'Múnich',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BODY:
      'Cuéntanos tus expectativas profesionales para que podamos recomendarte ofertas interesantes.',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_BUTTON: 'Entendido',
    LOSP_PREFERENCES_EXPERIMENT_EMPTY_POPUP_HEADLINE:
      'Debes seleccionar al menos un criterio.',
    LOSP_PREFERENCES_EXPERIMENT_HEADLINE:
      'Haz que los reclutadores y las reclutadoras vengan a ti',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_BUTTON: 'Nivel profesional',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_ENTRY: 'Principiante',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_HEADLINE:
      '¿Qué nivel profesional debe tener tu siguiente empleo?',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_MANAGER: 'Mánager',
    LOSP_PREFERENCES_EXPERIMENT_LEVEL_PROFESSIONAL: 'Con experiencia',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_DISCIPLINES: 'Áreas profesionales',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_HEADLINE:
      '¿Qué otras expectativas laborales tienes?',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_INDUSTRIES: 'Sectores',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_JOBTITLE: 'Puesto',
    LOSP_PREFERENCES_EXPERIMENT_OTHERS_WORKING_HOURS: 'Horario laboral',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_BUTTON: 'Tu lugar de trabajo',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HEADLINE:
      '¿Cómo quieres trabajar en el futuro?',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_HOMEOFFICE: '100 % desde casa',
    LOSP_PREFERENCES_EXPERIMENT_PLACE_ONSITE: 'En la oficina',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_BUTTON: 'Salario',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_EIGHTY: '80.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY: '40.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_FORTY_FIVE: '€45,000',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_HEADLINE: '¿Qué salario anual quieres?',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_SIXTY: '60.000 €',
    LOSP_PREFERENCES_EXPERIMENT_SALARY_THIRTY: '€30,000',
    LOSP_PREFERENCES_EXPERIMENT_SAVE: 'Guardar expectativas profesionales',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BODY:
      'Muchos empleadores interesantes y más de 20.000 reclutadores y reclutadoras buscan a gente como tú en XING. Consigue que las ofertas vengan a ti en forma de recomendaciones de empleo adaptadas a ti. ¡Hazte un perfil en XING!',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_BUTTON: 'Inscribirme ahora',
    LOSP_PREFERENCES_EXPERIMENT_SAVE_POPUP_HEADLINE:
      'Haz que las ofertas vengan a ti',
    LOSP_PREFERENCES_EXPERIMENT_SEE_MORE: 'Ver más',
    LOSP_PREFERENCES_EXPERIMENT_SUBHEADLINE:
      'Ahórrate el estrés de buscar empleo, simplemente configura los parámetros más importantes para ti.',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_HOME_OFFICE: '100% from home',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_MOSTLY_HOME: 'Mostly from home',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_OFFICE: 'In the office',
    LOSP_PREFERENCES_EXPERIMENT_WORKPLACE_PARTLY_HOME: 'Partly from home',
    LOSP_RECRUITERS_SECTION_COMPANY_CTA: 'Ver ofertas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AIRBUS:
      '80% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AMAZON:
      'Ventajas para empleados: descuentos, aparcamiento, eventos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AOK:
      'Más de 1 440 evaluaciones como «Muy bueno»',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_AUDI:
      '86 % está satisfecho con su salario ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BAHNE_GROTH:
      'Reclutadores para puestos en la sede de flaschenpost',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BASF:
      'Ventajas citadas a menudo: horario flexible, teletrabajo, pensión de empleo',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BMW:
      'Ventajas confirmadas por múltiples personas: comedor, pensión complementaria, descuentos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_BOSCH:
      'Ventajas confirmadas por múltiples personas: horarios flexibles, médico de empresa',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_CAROLA_LUDEWIG:
      'Reclutadores para personal de seguridad de diferentes niveles',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BAHN:
      '74% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_BANK:
      'Ventajas citadas a menudo: horario flexible, pensión de empleo',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DEUTSCHE_POST:
      'Más de 12.250 evaluaciones de empleados y candidatos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DM:
      '70% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_DUERENHOFF_GMBH:
      'Mejores 10 de kununu: los empleadores más familiares',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FATMA_KOC:
      'Búsqueda activa para el sector de los servicios financieros',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_FINJA_STRUBER:
      'Reclutadora en la oficina central de ROSSMANN',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_HUSEYIN_YALCIN:
      'Tiempo de respuesta: menos de 3 horas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_IKEA:
      'Ventajas citadas a menudo: descuentos, comedor, pensión de empleo',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ISABEL_STRUSCHKA:
      'Persona de contacto para finanzas, TI, sociedad y cultura',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_GOTZE:
      'Reclutadores en el sector Gestión y expertos en IT',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JAN_SCHENGBER:
      'Tiempo de respuesta: menos de 4 horas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JOHANNA_ECKERT:
      'Reclutador en el sector de la fiscalidad y las auditorías/Control financiero ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JONAS_MASANNECK:
      'Reclutadores en el sector Non-Tech & Life Sciences',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_JULIA_REICHHOFER:
      'Reclutadora para todos los puestos del Grupo Schmersal',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KAUFLAND:
      'Más de 2.867 evaluaciones de empleados y candidatos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_KRISTIN_SEMELKA:
      'Reclutadores en el sector de la formación',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_LIDL: 'kununu Top Company 2023',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MALTE_BALMER:
      'Tu persona de contacto para tus preguntas sobre las ofertas de empleo de OTTO',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MARIA_HEUCKE:
      'Pasión por nuestro trabajo #WeEmpowerPeople',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MEINESTADT_DE:
      '88% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_MIRIAM_DJAMBOU:
      'Consultoría en el sector IT e ingeniería',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_OTTOBOCK:
      'Ventajas citadas a menudo: entrada flexible, médico de empresa',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_PORSCHE:
      '95% está satisfecho con su salario',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_RALPH_OSTERMEIER:
      'Tu persona de contacto para ofertas de empleo de TI en EDEKA ',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_REWE:
      '61% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROBIN_MAURER:
      'Recruiting y branding de empleador para tres empresas',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_ROSSMANN:
      'Más de 1.621 evaluaciones de empleados y candidatos',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SAP:
      '93% de tasa de recomendación en los últimos dos años',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SARAH_BAUDZUS:
      'Más de 10 años en el sector de la atención sanitaria y hospitalaria',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_SIEMENS:
      '67% confirma los horarios flexibles como beneficio',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_STEFANIE_KLOCK:
      'Consultoría en el sector Especialistas en ventas y marketing',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VANESSA_STRAUCH:
      'Reclutadora en el sector del transporte y la logística',
    LOSP_RECRUITERS_SECTION_INSIGHTS_FOR_VERONIKA_GERSDORF:
      'Reclutadora para puestos de mano de obra y oficina',
    LOSP_RECRUITERS_SECTION_RECRUITER_CTA: 'Ver el perfil',
    LOSP_SEARCH_INSPIRATION_CAREER_LEVEL: 'Your career level',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_1: 'Work where’s best for you.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_5:
      'Free up time for other things in life.',
    LOSP_SEARCH_INSPIRATION_DESCRIPTION_CARD_6:
      'Start small or earn a little extra.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_CAREER_LEVEL_HEADLINE:
      'What’s your preferred career level?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION:
      'Pick what’s important to you for better job matches.',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_DESCRIPTION_2: 'It’s quick and simple!',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_SUBHEADLINE:
      'Pick what’s important to you for better job matches. It’s quick and simple!',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_MODAL_TITLE: 'Set your job preferences',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_SALARY_HEADLINE:
      'What are your minimum salary expectations?',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_TITLE: 'Set your job preferences',
    LOSP_SEARCH_INSPIRATION_PREFERENCES_WORKPLACE_HEADLINE:
      'Where would you like to work?',
    LOSP_SEARCH_INSPIRATION_SALARY: 'Your desired salary',
    LOSP_SEARCH_INSPIRATION_SET_PREFERENCES: 'Set preferences',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_1: 'Remote jobs',
    LOSP_SEARCH_INSPIRATION_TITLE_CARD_3: 'Jobs for career changers',
    LOSP_SEARCH_INSPIRATION_WORKPLACE: 'Your workplace',
    LOSP_SEO_SECTION_COMPANIES_DIRECTORY: 'Empresas de la A a la Z',
    LOSP_SEO_SECTION_HEADER_DIRECTORIES: 'Directorios',
    LOSP_SEO_SECTION_HEADER_JOB_ROLES: 'Puestos',
    LOSP_SEO_SECTION_HEADER_TOP_LOCATIONS: 'Ciudades clave',
    LOSP_SEO_SECTION_HEADER_TOP_SKILLS: 'Competencias clave',
    LOSP_SEO_SECTION_JOBS_DIRECTORY: 'Ofertas de la A a la Z',
    LOSP_SEO_SECTION_PEOPLE_DIRECTORY: 'Usuarios de la A a la Z',
    NATIVE_ADS_DOT_MENU_REPORT_OBJECT: 'Notificar este anuncio',
    NATIVE_ADS_LEARN_MORE_BUTTON: 'Más información',
    NATIVE_ADS_SPONSORED_LABEL: 'Patrocinado',
    PROFILE_TEASER_CARD_DESCRIPTION:
      'Es gratis y multiplica tus oportunidades en tu búsqueda de empleo.',
    PROFILE_TEASER_CARD_TITLE: 'Crea un perfil de XING',
    QR_CODE_BANNER_SUBTITLE:
      'Porque tu próximo trabajo se encuentra a un XING.',
    QR_CODE_BANNER_TITLE: 'Descargar la aplicación de XING',
    RECRUITERS_SECTION_FIRST_SUBTITLE:
      'Crea un perfil de XING y consigue que las ofertas vengan a ti',
    RECRUITERS_SECTION_FIRST_TITLE: 'Haz que las ofertas vengan a ti.',
    RECRUITERS_SECTION_FLAG_COMPANIES: 'Ofertas disponibles',
    RECRUITERS_SECTION_FLAG_RECRUITERS: 'Ofertas disponibles',
    RECRUITERS_SECTION_REGISTER_BUTTON: 'Crear un perfil',
    RECRUITERS_SECTION_REGISTER_WITH_GOOGLE_BUTTON: 'Seguir con Google',
    RECRUITERS_SECTION_SECOND_SUBTITLE:
      'Entra en contacto con más de 20 000 reclutadores y reclutadoras',
    RECRUITERS_SECTION_SECOND_TITLE: 'Conecta con éxito',
    REGISTER_SECTION_DATE_MARK: 'Hoy',
    REGISTER_SECTION_FIRST_TAG: 'Tus expectativas salariales',
    REGISTER_SECTION_HEADLINE: '4 solicitudes nuevas',
    REGISTER_SECTION_SECOND_TAG: 'Tu sector',
    REGISTER_SECTION_THIRD_TAG: 'Tu nivel profesional preferido',
    SEO_SECTION_TITLE: 'Sugerencias de búsqueda',
    TITLE_CARD_1: 'Ofertas con teletrabajo',
    TITLE_CARD_2: 'Trabajos con horarios flexibles',
    TITLE_CARD_3: 'Empleo en diferentes campos',
    TITLE_CARD_4: 'Ofertas con los mayores salarios',
    TITLE_CARD_5: 'Puestos a jornada parcial',
    TITLE_CARD_6: 'Minijobs',
    WELCOME_APP_MINIREG_ERROR_EMAIL:
      'Comprueba tu dirección de correo electrónico.',
    WELCOME_APP_MINIREG_ERROR_FIRST_NAME: 'Introduce aquí tu nombre.',
    WELCOME_APP_MINIREG_ERROR_LAST_NAME: 'Introduce aquí tu(s) apellido(s).',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_EMAIL:
      'Por razones de seguridad, es recomendable que no utilices la misma contraseña que para tu correo electrónico.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_LAST_NAME:
      'Por razones de seguridad, es recomendable que tu contraseña no coincida con tu apellido.',
    WELCOME_APP_MINIREG_ERROR_PASSWORD_TOO_LONG:
      'Selecciona una contraseña que no supere los 1024 caracteres.',
    WELCOME_APP_MINIREG_ERROR_PHONE: 'Comprueba tu número de teléfono.',
    WELCOME_APP_MINIREG_ERROR_TANDC:
      'Debes confirmar que aceptas las Condiciones Generales y la normativa de Protección de Datos',
    WELCOME_COMPLETION_HEADLINE: '¡Bienvenid@ a XING!',
    WELCOME_COMPLETION_PAGE_META_TITLE: '¡Bienvenid@ a XING! | XING',
    WELCOME_COMPLETION_SUBLINE:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_B:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_C:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_D:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_COMPLETION_SUBLINE_E:
      'Solo faltan unos datos para completar tu inscripción:',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_BODY:
      'Por favor, vuelve a comprobar que la dirección de correo electrónico es correcta. Si lo es, {link}.',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_CTA:
      'Corregir la dirección de correo electrónico',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_HEADER:
      'No ha sido posible entregar tu mensaje de correo electrónico',
    WELCOME_CONFIRMATION_DEFAULT_BOUNCED_SUPPORT_LINK_TEXT:
      'Ponte en contacto con nosotros',
    WELCOME_CONFIRMATION_DEFAULT_BUTTON:
      '¿No has recibido el correo electrónico?',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1: 'Activa ahora tu cuenta de acceso:',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_C:
      'Te hemos enviado un enlace a {email}.*',
    WELCOME_CONFIRMATION_DEFAULT_COPY_1_D:
      '... te enviamos un enlace de confirmación a {email}.*',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2:
      'Te hemos enviado el enlace a {email}. *',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_C:
      'Haz clic sobre él para confirmar tu dirección de correo electrónico.',
    WELCOME_CONFIRMATION_DEFAULT_COPY_2_D:
      'Haz clic sobre él para confirmar tu registro.',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE: '¡Casi hemos terminado!',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_C: 'Tienes un mensaje:',
    WELCOME_CONFIRMATION_DEFAULT_HEADLINE_D: 'Por tu seguridad...',
    WELCOME_CONFIRMATION_DEFAULT_SUFFIX:
      '*Consulta tu carpeta de correo basura o spam. Si utilizas Gmail, a lo mejor está en la pestaña "Promociones" o "Social".',
    WELCOME_CONFIRMATION_EDIT_EMAIL_BUTTON:
      'Enviar un nuevo enlace de inscripción',
    WELCOME_CONFIRMATION_EDIT_EMAIL_COPY: 'Si no, puedes corregirla aquí:',
    WELCOME_CONFIRMATION_EDIT_EMAIL_HEADLINE:
      '¿La dirección de correo electrónico está bien?',
    WELCOME_CONFIRMATION_EDIT_EMAIL_LABEL: 'Correo electrónico',
    WELCOME_CONFIRMATION_EDIT_EMAIL_REQUEST_ERROR:
      'Parece que se ha producido un error. Vuelve a intentarlo de nuevo.',
    WELCOME_CONFIRMATION_EMAIL_RESENT_BUTTON:
      '¿Sigues sin recibir el correo electrónico?',
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_1:
      'Te hemos enviado un nuevo enlace de activación a: {email}',
    WELCOME_CONFIRMATION_EMAIL_RESENT_COPY_2:
      'Haz clic en el enlace de activación del mensaje de correo electrónico que has recibido para completar el proceso de inscripción.',
    WELCOME_CONFIRMATION_EMAIL_RESENT_HEADLINE: 'Ahora sí:',
    WELCOME_CONFIRMATION_PAGE_META_TITLE: 'Activar la cuenta de XING | XING',
    WELCOME_GDPR_IMG_ALT:
      'La política de privacidad de XING está en línea con el RGPD',
    WELCOME_INVITATION_HEADLINE: '{firstname} {lastname} te ha invitado.',
    WELCOME_INVITATION_SUBLINE:
      'Regístrate para aceptar la solicitud de contacto de {firstname}.',
    WELCOME_LANGUAGE_PAGE_META_TITLE: 'Seleccionar el idioma | XING',
    WELCOME_LANGUAGE_SELECT_ENGLISH_LABEL: 'English',
    WELCOME_LANGUAGE_SELECT_FRENCH_LABEL: 'Français',
    WELCOME_LANGUAGE_SELECT_GERMAN_LABEL: 'Deutsch',
    WELCOME_LANGUAGE_SELECT_HEADLINE: '¿En qué idioma quieres usar XING?',
    WELCOME_LANGUAGE_SELECT_ITALIAN_LABEL: 'Italiano',
    WELCOME_LANGUAGE_SELECT_SPANISH_LABEL: 'Español',
    WELCOME_LOGIN_FORM_EMAIL_REQUIRED_ERROR:
      'Escribe aquí tu dirección de correo electrónico.',
    WELCOME_LOGIN_FORM_FIRSTNAME_REQUIRED_ERROR: 'Escribe aquí tu nombre.',
    WELCOME_LOGIN_FORM_LASTNAME_REQUIRED_ERROR:
      'Escribe aquí tu(s) apellido(s).',
    WELCOME_LOGIN_FORM_PASSWORD_REQUIRED_ERROR: 'Escribe aquí tu contraseña.',
    WELCOME_LOGIN_FORM_PASSWORD_REQURED_ERROR: 'Escribe aquí tu contraseña.',
    WELCOME_LOGIN_FORM_REMEMEMBER_ME_LABEL: 'Seguir conectado',
    WELCOME_LOGIN_FORM_SUBMIT_REQUEST_ERROR:
      'Parece que eso no ha funcionado. Por favor, vuelve a intentarlo.',
    WELCOME_LOGIN_FORM_USERNAME_REQUIRED_ERROR:
      'Escribe aquí tu correo electrónico.',
    WELCOME_LOGIN_HEADLINE: '¡Bienvenid@ de nuevo!',
    WELCOME_LOGIN_PASSWORD_LABEL: 'Contraseña',
    WELCOME_LOGIN_PROBLEMS_LOGGING_IN: '¿No consigues iniciar una sesión?',
    WELCOME_LOGIN_SUBMIT_LABEL: 'Conectarme',
    WELCOME_LOGIN_USERNAME_LABEL: 'Correo electrónico',
    WELCOME_REGISTRATION_CTA_REG_7503_E: 'Crear un perfil nuevo',
    WELCOME_REGISTRATION_CTA_REG_7504_A: 'Siguiente',
    WELCOME_REGISTRATION_CTA_REG_7504_B: 'Registrarse',
    WELCOME_REGISTRATION_CTA_REG_7504_C: 'Registrarse ahora',
    WELCOME_REGISTRATION_CTA_REG_7504_D: 'Crear un perfil',
    WELCOME_REGISTRATION_CTA_REG_7504_E: 'Unirme a XING',
    WELCOME_REGISTRATION_DATAPROTECTION_LABEL: 'Política de privacidad',
    WELCOME_REGISTRATION_DATAPROTECTION_LINK:
      'https://privacy.xing.com/en/privacy-policy',
    WELCOME_REGISTRATION_EMAIL_LABEL: 'Correo electrónico',
    WELCOME_REGISTRATION_FIRSTNAME_LABEL: 'Nombre',
    WELCOME_REGISTRATION_HEADLINE: 'Consigue tu perfil gratuito de XING:',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_B:
      '¡Regístrate gratis en tan solo 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_C:
      '¡Regístrate gratis en tan solo 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_D:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7088_E:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_B:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_C:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7396_D:
      'Regístrate ahora: ¡es gratis y solo necesitas 2 minutos!',
    WELCOME_REGISTRATION_HEADLINE_REG_7550_CMP:
      'Inscríbete ahora y usa la cuenta Premium 30 días gratis:',
    WELCOME_REGISTRATION_IGNORE_SOFT_EMAIL_ERRORS_LABEL:
      'Sí, {email} es mi dirección de correo electrónico.',
    WELCOME_REGISTRATION_LASTNAME_LABEL: 'Apellido(s)',
    WELCOME_REGISTRATION_PASSWORD_LABEL: 'Contraseña',
    WELCOME_REGISTRATION_RECAPTCHA_HEADLINE: 'Casi hemos terminado.',
    WELCOME_REGISTRATION_RECAPTCHA_PARAGRAPH:
      'Para protegerte a ti y a otros usuarios del correo basura, queremos asegurarnos de que eres una persona.',
    WELCOME_REGISTRATION_SOFT_EMAIL_ERROR:
      'Vuelve a comprobar que la dirección de correo electrónico es correcta.',
    WELCOME_REGISTRATION_SUBMIT_LABEL: 'Siguiente',
    WELCOME_REGISTRATION_TANDC_DESCRIPTION:
      'A través de la inscripción, declaro conocer las {tandc} y la {dataprotection}.',
    WELCOME_REGISTRATION_TANDC_LABEL: 'Condiciones Generales',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_BUTTON: 'Pulsar durante 5 segundos',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_ERROR:
      'Lo sentimos, parece que se ha producido un error. Pulsa el botón durante 5 segundos.',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_HEADLINE: '¡Una última comprobación!',
    WELCOME_REGISTRATION_TIMER_CAPTCHA_PARAGRAPH:
      'Pulsa el siguiente botón durante 5 segundos para superar nuestro control de seguridad.',
    WELCOME_REGISTRATION_VIA_CV_BAD_FILE_ERROR_LABEL:
      'No hemos podido cargar el archivo {fileName}. Puede que sea demasiado grande o que tenga un formato no compatible.',
    WELCOME_REGISTRATION_VIA_CV_BUTTON_LABEL: 'Subir CV',
    WELCOME_REGISTRATION_VIA_CV_COMMON_ERROR_LABEL:
      'Lo sentimos, se ha producido un error. Vuelve a intentarlo.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_DEFAULT:
      'Sube tu currículum y completaremos automáticamente tu perfil de XING con tus datos.',
    WELCOME_REGISTRATION_VIA_CV_DESCRIPTION_SUCCESS:
      'Hemos completado tu CV automáticamente con tus datos.{br}{br} Echa un vistazo para asegurarte de que todo está bien y completa la información que falta.',
    WELCOME_REGISTRATION_VIA_CV_FILE_INFO_LABEL:
      'Formato: PDF, Word (.docx) o pages (máx. 100 MB)',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_DEFAULT: 'Gana tiempo',
    WELCOME_REGISTRATION_VIA_CV_HEADLINE_SUCCESS: 'Tu CV',
    WELCOME_SEARCHPAGE_CTA:
      'Descubre aquí tu siguiente puesto de trabajo o reencuentra a compañeros y amigos:',
    WELCOME_SEARCHPAGE_HEADLINE: 'Encuentra ofertas de empleo o usuarios:',
    WELCOME_SEARCHPAGE_JOBS_BUTTON: 'Empleo',
    WELCOME_SEARCHPAGE_JOBS_PLACEHOLDER:
      'Introducir el cargo o la palabra clave',
    WELCOME_SEARCHPAGE_MEMBERS_BUTTON: 'Miembros',
    WELCOME_SEARCHPAGE_MEMBERS_PLACEHOLDER: 'Nombre, empresa o palabra clave',
    WELCOME_SEARCHPAGE_SEARCH_BUTTON: 'Buscar',
    WELCOME_SIGNUP_FORM_SUBMIT_REQUEST_ERROR:
      'Parece que no ha funcionado. Por favor, vuelve a intentarlo.',
    WELCOME_SIGNUP_FORM_VALIDATE_RELOAD_ERROR:
      'Se ha producido un error. Por favor, habilita las cookies de tu navegador y vuelve a cargar la página.',
    WELCOME_SIGNUP_FORM_VALIDATE_REQUEST_ERROR:
      'Parece que no ha funcionado. Por favor, vuelve a intentarlo.',
    WELCOME_SIGNUP_PAGE_META_TITLE: 'Inscríbete ahora | XING',
    WELCOME_SIGNUP_USP_CONTACTS_COPY:
      'Conecte con más de 21 millones de usuarios y usuarias.',
    WELCOME_SIGNUP_USP_CONTACTS_TITLE: 'Contactos valiosos',
    WELCOME_SIGNUP_USP_FREE_COPY:
      'La suscripción estándar de XING es y seguirá siendo gratuita.',
    WELCOME_SIGNUP_USP_FREE_TITLE: 'Inscripción gratuita',
    WELCOME_SIGNUP_USP_PRESENCE_COPY:
      'Únete a la mayor red profesional en línea de los mercados de habla germana.',
    WELCOME_SIGNUP_USP_PRESENCE_TITLE: 'Mayor presencia',
    WELCOME_SIGNUP_USP_SECURITY_COPY:
      'XING cumple la ley de protección de datos alemana.',
    WELCOME_SIGNUP_USP_SECURITY_TITLE: 'Máxima seguridad',
    WELCOME_SIGNUP_USPS_TITLE:
      'XING: todo lo que necesitas para el éxito profesional.',
    WELCOME_STARTPAGE_APP_STORE_BADGE_ALT: 'Descargar en la App Store',
    WELCOME_STARTPAGE_CULTURE_CHECK_BUTTON: 'Ir al análisis cultural',
    WELCOME_STARTPAGE_CULTURE_CHECK_IMG_ALT:
      'Gráfico del análisis de la cultura corporativa',
    WELCOME_STARTPAGE_CULTURE_CHECK_TEXT:
      '¿Qué prefieres: jerarquías planas o instrucciones claras? Hay muchos factores que influyen en la cultura empresarial, y puedes averiguar cuáles son los que más te importan. Así sabrás qué buscar en tu próximo trabajo. Comprueba ahora el análisis cultural:',
    WELCOME_STARTPAGE_CULTURE_CHECK_TITLE:
      'Encuentra el mejor lugar de trabajo para ti.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_BUTTON: 'Ver la brújula cultural',
    WELCOME_STARTPAGE_CULTURE_COMPASS_IMG_ALT:
      'Un gráfico que muestra la cultura empresarial con una escala que comprende desde tradicional hasta moderna.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TEXT:
      '¿Alguna vez te has preguntado cómo son las personas que trabajan en XYZ? La brújula cultural te muestra cómo es trabajar para la empresa te interesa. Aquí averiguas si es una empresa más tradicional o moderna en su enfoque diario, el equilibrio entre vida personal y laboral y muchas cosas más.',
    WELCOME_STARTPAGE_CULTURE_COMPASS_TITLE: 'Seguir la brújula cultural',
    WELCOME_STARTPAGE_DOWNLOAD_APP_CTA:
      '¿Tienes ganas de conocer la nueva aplicación de XING?',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_01:
      'Regístrate gratis en solo 2 minutos:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_02:
      'Regístrate gratis en solo 2 minutos:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_03:
      'Crea tu cuenta gratuita en solo 2 minutos:',
    WELCOME_STARTPAGE_FORM_TITLE_REG_7371_04:
      'Regístrate gratis en solo 2 minutos:',
    WELCOME_STARTPAGE_GOOGLE_PLAY_BADGE_ALT: 'Ahora en Google Play',
    WELCOME_STARTPAGE_HEADER_BUTTON: 'Regístrate ya',
    WELCOME_STARTPAGE_HEADER_IMAGE_ALT:
      'Mujer feliz, reclinada en su silla de oficina',
    WELCOME_STARTPAGE_HEADER_SUBTITLE: '¡Crea tu propio XING!',
    WELCOME_STARTPAGE_HEADER_TITLE:
      '¡Ha llegado el momento de tu desarrollo laboral!',
    WELCOME_STARTPAGE_JOBS_DIRECTORY_NAVIGATION_TITLE:
      'Ofertas de empleo por letras iniciales',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_BUTTON: 'Regístrate gratis',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_SUBTITLE:
      'O nosotros buscamos por ti. Pruébalo:',
    WELCOME_STARTPAGE_JOBS_VERSION_HEADER_TITLE:
      'Encuentra el trabajo,{br}\nque buscas:',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_DOGS_FRIENDLY:
      'Se admiten perros',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_FLEXIBILITY: 'Horarios flexibles',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_PART_TIME: 'Tiempo parcial',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_FILTER_REMOTE: 'Teletrabajo',
    WELCOME_STARTPAGE_JOBS_VERSION_JOB_INPUT_PLACEHOLDER:
      'Introducir el nombre del puesto o una palabra clave',
    WELCOME_STARTPAGE_JOBS_VERSION_LOCATION_INPUT_PLACEHOLDER: 'Lugar',
    WELCOME_STARTPAGE_JOBS_VERSION_SEARCH_SUBMIT_BUTTON: 'Encontrar un trabajo',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_IMG_ALT:
      'Dibujo de una persona y de un CV',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TEXT:
      'Ya sea por una mudanza, un cambio personal o simplemente tus ganas de encontrar algo nuevo: XING te ayuda alcanzar tus metas profesionales, sin perderte por el camino. ¡Muéstrate tal y como eres!',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TITLE:
      'En XING eres mucho más que un currículum',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_IMG_ALT:
      'Dibujo de una persona con una imagen en la que aparecen varias cabezas',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TEXT:
      'En XING, más de 20.000 reclutadores y reclutadoras están a un simple mensaje de distancia. Conoce a auténticos expertos en recursos humanos, de tu sector y del mercado laboral, y ponte en contacto con reclutadores(as) y trabajadores(as) de la empresa que te interesa. ¡Únete a ellos, únete a XING! ',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TITLE:
      'Habla con las personas indicadas',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_IMG_ALT:
      'Dibujo de una persona con sombreros o cascos correspondientes a diferentes profesiones',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TEXT:
      'Aquí encuentras las mejores ofertas de empleo y recibes las recomendaciones indicadas en el momento oportuno. Para descubrir qué te motiva. Para seguir formándote. Para conocer empleadores interesantes, con la cultura empresarial que te gusta.',
    WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TITLE:
      '1,4 millones de ofertas y un sinfín de oportunidades',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_BUTTON: 'Regístrate',
    WELCOME_STARTPAGE_JOBSFINDER_CTA_TEXT:
      '¿Cómo afectan el lugar y el sector laboral en el salario? Averígualo en XING.',
    WELCOME_STARTPAGE_JOBSFINDER_IMG_ALT:
      'Una mujer intenta trabajar en una postura incómoda',
    WELCOME_STARTPAGE_JOBSFINDER_SUBTITLE: 'Sé tú mismo/a:',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_CONSULTING: 'Consultoría',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_IT: 'Tecnologías de la información',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_LOGISTICS: 'Logística',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MARKETING: 'Marketing',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_MORE_JOBS: 'Más sectores',
    WELCOME_STARTPAGE_JOBSFINDER_SUGGESTION_PROJECT_MANAGEMENT:
      'Gestión de proyectos',
    WELCOME_STARTPAGE_JOBSFINDER_TITLE: 'Encuentra el trabajo que buscas.',
    WELCOME_STARTPAGE_KEY_FEATURES_EVENTS: '1,7 millones de eventos',
    WELCOME_STARTPAGE_KEY_FEATURES_JOBS: 'Más de 250.000 ofertas de empleo',
    WELCOME_STARTPAGE_KEY_FEATURES_MEMBERS: '20 millones de usuarios',
    WELCOME_STARTPAGE_KEY_FEATURES_NEWS: 'Noticias del sector todos los días',
    WELCOME_STARTPAGE_MAIN_CTA_BUTTON: 'Regístrate gratis',
    WELCOME_STARTPAGE_MAIN_CTA_TEXT:
      'XING: la mayor red profesional en los países de habla germana.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION:
      'XING es tu asistente profesional personal. Entabla nuevos contactos y descubre trabajos y novedades interesantes.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_B:
      'Encuentra el trabajo que mejor se ajusta a ti.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_C:
      'Un mismo lugar con muchas personas interesantes. Descubre las novedades más actuales, comparte ideas y busca inspiración en XING.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_D:
      'Averigua qué hay de nuevo entre tus compañeros, mantente en contacto  y habla sobre lo que te apasiona con quienes comparten tus intereses.',
    WELCOME_STARTPAGE_MAIN_DESCRIPTION_REG_7088_E:
      'Un mismo lugar con muchas personas. Comparte ideas, busca inspiración y descubre las novedades más actuales en XING.',
    WELCOME_STARTPAGE_MAIN_SUBTITLE_REG_7494:
      'Für Dein Leben. Für Deinen Job. Für Dein Job-Leben.',
    WELCOME_STARTPAGE_MAIN_TITLE: 'XING - Ideas para una nueva vida laboral',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_B: 'Encuentra el trabajo que buscas',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_C:
      'Usa tu red de contactos y llega más lejos.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_D:
      '¿Tu carrera profesional? Es cuestión de contactos.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7088_E:
      'Conoce a las personas clave para tu carrera profesional.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_01:
      'Vive mejor, trabaja mejor: con el trabajo que mejor te va.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_02:
      'No lo pospongas más, encuentra el trabajo perfecto para ti.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_03: 'XING: tu aliado profesional.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7371_04:
      'Vive mejor, trabaja mejor: con el trabajo que mejor te va.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7494: 'Weil Du’s Dir vorgenommen hast.',
    WELCOME_STARTPAGE_MAIN_TITLE_REG_7747:
      'Ha llegado el momento de ser tú mismo(a).{br}\n¡Crea tu propio XING!',
    WELCOME_STARTPAGE_MEMBER_DIRECTORY_NAVIGATION_TITLE:
      'Miembros por iniciales',
    WELCOME_STARTPAGE_META_DESCRIPTION:
      'XING es tu acompañante personal en la vida laboral. Encuentra nuevos contactos profesionales y descubre ofertas de empleo, eventos, noticias y grupos interesantes.',
    WELCOME_STARTPAGE_META_DESCRIPTION_JOB_SEARCH:
      '✓ Análisis cultural ✓ Evaluaciones de empleadores ✓ e-Learning ✓ Contacto con reclutadores - Crea tu propio XING para disfrutar de tu trabajo e incrementar tu satisfacción laboral',
    WELCOME_STARTPAGE_META_TITLE: 'XING - Mejora tu vida laboral',
    WELCOME_STARTPAGE_META_TITLE_JOB_SEARCH:
      'XING - Encuentra el trabajo que de verdad te va.',
    WELCOME_STARTPAGE_OG_SITENAME: 'XING',
    WELCOME_STARTPAGE_OG_TITLE: 'XING – Ideas para un nuevo mundo profesional',
    WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON: 'Seguir con Apple',
    WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON: 'Seguir con Google',
    WELCOME_STARTPAGE_XINGGUIDE_BUTTON: 'Ver más',
    WELCOME_STARTPAGE_XINGGUIDE_IMG_ALT:
      'Un mensaje de XING Guide, con una oferta de empleo recomendada',
    WELCOME_STARTPAGE_XINGGUIDE_TEXT:
      '¿Buscas empleo o empiezas un trabajo nuevo? Esta guía te ayudará con consejos sobre cómo mejorar tu presencia en XING: desde la optimización de tu perfil hasta recomendaciones de contactos o artículos interesantes, en función de lo que necesitas.',
    WELCOME_STARTPAGE_XINGGUIDE_TITLE: 'Tu mayor apoyo profesional',
    WELCOME_TOGGLE_FORM_BUTTON_LOGIN: 'Iniciar sesión',
    WELCOME_TOGGLE_FORM_BUTTON_REGISTER: 'Registrarme',
    XAM_GENERIC_ERROR_MESSAGE:
      'Se ha producido un error. Por favor, vuelve a intentarlo más tarde.',
    XAM_LEAD_AD_CUSTOM_QUESTION_PLACEHOLDER: 'Introduce tu respuesta.',
    XAM_LEAD_AD_FORM_THANKS_CTA_DOWNLOAD_NOW: 'Download now',
    XAM_LEAD_AD_FORM_THANKS_CTA_TRY_NOW: 'Try now',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_COMPANY_WEBSITE: 'Visit company website',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_NOW: 'Visit now',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_XING_PAGE: 'Visit XING page',
    XAM_LEAD_AD_PREVIEW_CONFIRMATION_SUCCESS_MESSAGE: 'Solicitud enviada',
    XAS_ARMSTRONG_LEAD_AD_FORM_THANKS_BUTTON_COPY: 'Ver la página de XING',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Volver a intentar',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: 'Por favor, vuelve a intentarlo.',
    XDS_EMPTYSTATE_ERROR_TITLE: 'Parece que se ha producido un error.',
  },
};
